import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CatGoalRegionModel } from 'src/app/model/cat-goal-region.model';
import { CatGoalStateModel } from 'src/app/model/cat-goal-state.model';
import { CatGoalStateService } from 'src/oldApp/services/cat-goal-state.service';
import { CreatorService } from 'src/app/services/creator.service';
import { ModalGoalStateComponent } from 'src/oldApp/shared/modal-goal-state/modal-goal-state.component';

@Component({
  selector: 'app-cat-goal-state',
  templateUrl: './cat-goal-state.component.html',
  styleUrls: ['./cat-goal-state.component.css']
})
export class CatGoalStateComponent implements OnInit {
  // estado pagina
  public page:string='CatGoalRegion';
  public viewStatus=0;
  public states:CatGoalStateModel[]=[];

  // opciones datatables
  dtOptions={
    order:[],
    responsive:true,
    columnDefs: [
      { responsivePriority: 1, width:100, targets: -1 }
    ],
    bLengthChange: true,
    searching :true,
    dom:'<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
    buttons: ['csv', 'excel'],
    autoWidth:false,
    // pagingType: 'full_numbers',
    paging:true,
    pageLength: 100,
    language: {
      processing: 'Procesando...',
      search: 'Buscar:',
      lengthMenu: 'Mostrar _MENU_ elementos',
      info: 'Mostrando del _START_ al _END_ de _TOTAL_ elementos',
      infoEmpty: 'Mostrando ningún elemento.',
      infoFiltered: '(filtrado _MAX_ elementos total)',
      infoPostFix: '',
      loadingRecords: 'Cargando registros...',
      zeroRecords: 'No se encontraron registros',
      emptyTable: 'No hay datos disponibles en la tabla',
      paginate: {
        first: 'Primero',
        previous: 'Anterior',
        next: 'Siguiente',
        last: 'Último'
      },
      aria: {
        sortAscending: ': Activar para ordenar la tabla en orden ascendente',
        sortDescending: ': Activar para ordenar la tabla en orden descendente'
      },
      // dom: 'Bfrtip',
      buttons: [
        'excel'
      ]
    }
  };

  ////////////
  constructor(
    private modalService:NgbModal,
    private creator:CreatorService,
    private goalStateService:CatGoalStateService,
    private toastr:ToastrService
  ) { }
  ngOnInit() {
    this.getCatalogs();
  }

  // 
  add=()=> {
    let state=this.creator.newCatGoalState();
    let modalRef=this.modalService.open(ModalGoalStateComponent, {centered:true, backdrop:'static', keyboard:false});
    modalRef.componentInstance.state={...state};
    modalRef.componentInstance.page=this.page;
    modalRef.componentInstance.mode='create';
    modalRef.result.then(
      data=> console.log(data),
      reason=> {
        console.log(reason);
        this.viewStatus=0;
        this.getCatalogs();
      }
    );
  }
  edit=(state:CatGoalRegionModel)=> {
    let modalRef=this.modalService.open(ModalGoalStateComponent, {centered:true, backdrop:'static', keyboard:false});
    modalRef.componentInstance.state={...state};
    modalRef.componentInstance.page=this.page;
    modalRef.componentInstance.mode='edit';
    modalRef.result.then(
      data=> console.log(data),
      reason=> {
        console.log(reason);
        this.viewStatus=0;
        this.getCatalogs();
      }
    );
  }

  // INFO
  getCatalogs=()=> {
    this.goalStateService.getAll()
      .pipe(
        tap((resp:any)=> {
          this.states=resp.data;
          this.viewStatus=1;
        }),
        catchError(error=> {
          this.viewStatus=-1;
          return of(this.toastr.error('Ocurrió un error al leer el catálogo de estados.'));
        })
      )
      .subscribe();
  }
}